import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class BlueprintAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // Metric Blueprint

  newBlueprintBucket = ApiRoutes.Metric.Blueprint.NewBlueprintBucket
  newBlueprintMetric = ApiRoutes.Metric.Blueprint.NewBlueprintMetric
  goalType = ApiRoutes.Metric.Blueprint.GoalType
  metricBenchmark = ApiRoutes.Metric.Blueprint.MetricBenchmark
  bucketName = ApiRoutes.Metric.Blueprint.BucketName
  delBucket = ApiRoutes.Metric.Blueprint.DeleteBucket
  metricName = ApiRoutes.Metric.Blueprint.MetricName
  delMetric = ApiRoutes.Metric.Blueprint.DeleteMetric
  metricValueType = ApiRoutes.Metric.Blueprint.MetricValueType
  assignMetrics = ApiRoutes.Metric.Blueprint.AssignMetrics
  dndBucket = ApiRoutes.Metric.Blueprint.DndBucket
  dndMetric = ApiRoutes.Metric.Blueprint.DndMetric

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  // Metric Blueprint

  createNewBlueprintBucket = (token: string, metric_bucket: any) => {
    return this.instance({
      method: this.newBlueprintBucket.Method,
      url: this.newBlueprintBucket.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { metric_bucket: metric_bucket },
    })
  }

  createNewBlueprintMetric = (
    token: string,
    metric_bucket_id: any,
    metric_name: any,
  ) => {
    return this.instance({
      method: this.newBlueprintMetric.Method,
      url: this.newBlueprintMetric.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { metric_bucket_id: metric_bucket_id, metric_name: metric_name },
    })
  }

  // endpoint to add new metric with new API
  createNewMetric = (token: string, data: any) => {
    return this.instance({
      method: this.newBlueprintMetric.Method,
      url: this.newBlueprintMetric.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  updateMetricValueType = (token: string, data: any) => {
    return this.instance({
      method: this.metricValueType.Method,
      url: this.metricValueType.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        metric_id: data?.metricId,
        column_id: data?.columnId,
        column_datatype: data?.value,
      },
    })
  }

  updateGoalType = (token: string, data: any) => {
    return this.instance({
      method: this.goalType.Method,
      url: this.goalType.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        metric_id: data?.metricId,
        goal_type: data?.value,
      },
    })
  }

  updateMetricBenchmark = (token: string, data: any) => {
    return this.instance({
      method: this.metricBenchmark.Method,
      url: this.metricBenchmark.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        metric_id: data?.metricId,
        metric_benchmark: data?.value,
      },
    })
  }

  assignMetricsToGroup = (token: string, data: any) => {
    return this.instance({
      method: this.assignMetrics.Method,
      url: this.assignMetrics.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { groups: data?.selectedGroups, metrics: data?.selectedMetrics },
    })
  }

  updateBucketName = (token: string, data: any) => {
    return this.instance({
      method: this.bucketName.Method,
      url: this.bucketName.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        metric_bucket: data?.value,
        metric_bucket_id: data?.bucketId,
      },
    })
  }

  deleteBucket = (token: string, bucketId: any) => {
    return this.instance({
      method: this.delBucket.Method,
      url: this.delBucket.EndPoint(bucketId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  updateMetricName = (token: string, data: any) => {
    return this.instance({
      method: this.metricName.Method,
      url: this.metricName.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        metric_name: data?.value,
        metric_id: data?.metricId,
      },
    })
  }

  deleteMetric = (token: string, metricId: any) => {
    return this.instance({
      method: this.delMetric.Method,
      url: this.delMetric.EndPoint(metricId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  resequenceBucket = (token: string, data: any) => {
    return this.instance({
      method: this.dndBucket.Method,
      url: this.dndBucket.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  resequenceMetric = (token: string, data: any) => {
    return this.instance({
      method: this.dndMetric.Method,
      url: this.dndMetric.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }
}
